(function () {
  window.SPCLST = window.SPCLST || {};
  window.SPCLST.modules = window.SPCLST.modules || {};

  window.SPCLST.modules.footer = function (helpers) {
    var query = helpers.query;
    var queryAll = helpers.queryAll;
    var on = helpers.on;
    var parseBool = helpers.parseBool;
    var isMobileViewport = helpers.isMobileViewport;
    var isDesktopNavViewport = helpers.isDesktopNavViewport;

    var footerSections = queryAll('.footer-expandable-section');
    function syncFooterStateForViewport() {
      footerSections.forEach(function (section) {
        if (isMobileViewport()) {
          section.classList.remove('is-open');
        } else {
          section.classList.add('is-open');
        }
      });
    }

    syncFooterStateForViewport();


    window.addEventListener('resize', syncFooterStateForViewport);

    footerSections.forEach(function (section) {
      var header = query('.footer-header-container', section);
      if (!header) return;

      header.addEventListener('click', function () {
        if (!isMobileViewport()) return;
        section.classList.toggle('is-open');
      });
    });
  };
})();
